import React from 'react';
import Komutlar from './pages/komutlar.js';
import AnaSayfa from './pages/ana-sayfa.js';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

function App() {
    return (
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<AnaSayfa />} />
          <Route path='/komutlar' element={<Komutlar />} />
        </Routes>
      </BrowserRouter>
    );
}

export default App;
